import { render, staticRenderFns } from "./ksOutpatientVisitRegionPage.vue?vue&type=template&id=6b4ca0d8&scoped=true&"
import script from "./ksOutpatientVisitRegionPage.vue?vue&type=script&lang=js&"
export * from "./ksOutpatientVisitRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./ksOutpatientVisitRegionPage.vue?vue&type=style&index=0&id=6b4ca0d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ca0d8",
  null
  
)

export default component.exports